import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import Modal from '../../modal/Modal';
import animation from '../../../images/load-rewards-screen-animation.gif';

var RewardsUpdatingOverlay = function RewardsUpdatingOverlay(props) {
  var show = props.show;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      gif = _useState2[0],
      setGif = _useState2[1];

  useEffect(function () {
    if (show) {
      setGif("".concat(animation, "?").concat(Date.now()));
    } else {
      setGif(null);
    }
  }, [show]);
  return /*#__PURE__*/React.createElement(Modal, {
    className: 'rewards-updating-overlay',
    show: show,
    hide: function hide() {},
    hideCloseButton: false,
    backdrop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: 'rewards-updating-overlay__container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'rewards-updating-overlay__animation-container'
  }, gif && /*#__PURE__*/React.createElement("img", {
    className: 'rewards-updating-overlay__animation',
    src: gif,
    alt: 'Loading Rewards',
    autoPlay: true
  }))));
};

export default RewardsUpdatingOverlay;